
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import loginApi from '@/apis/login/login'
  import urlConfig from '@/Configurations/urlConfig'
  import {getSchoolConfig,getUrlQuery,getMobilexdomain} from '@/utils/utils';
  import {getUserInfo} from "@/apis/common";
  import {Toast,Dialog} from "vant";
  import i18n from '@/lang';

  @Component({
    name: "loginOrRegist"
  })
  export default class LoginOrRegist extends Vue {
    private bannerpic:string = '';
    private schoolName:string = '';

    private wechat_code:string = '';
    private loginType:string = '';
    private code:string ='';
    private userName:string = '';
    private password:string = ''
    private error:string = '';
    private phone:string = '';
    private sessionid = ''
    private picCodeUrl:string = ''
    private isShowPopUp:boolean = false;
    private picCodeInput:string = '';
    private checkPicCodeInputError:boolean = false;
    private checkPicCodeInputErrorMessage:string = i18n.t('ktpMy.请输入正确的验证码') as string
    private timeLeftNumber:number = 0;
    private loginButtonText:string = i18n.t('Account.登录') as string;
    private shareClassFromCode:any=null

    constructor() {
      super();
      this.loginType = 'usrNamePwd';
      this.loginButtonText = i18n.t('Account.登录') as string;
    }

    get showWechatLogin(){
      return urlConfig.showWechatLogin;
    }

    get canRegister(){
      return urlConfig.canRegister;
    }

    @Watch('loginType')
    onLoginTypeChange(val:string){
      this.loginButtonText = i18n.t('Account.登录') as string;
    }

    changeLoginMethod (type:string):void {
      this.clearForm();
      this.loginType = type;
    }

    forgotPwd() {
      this.$router.push('/findPassword')
    }

    goRegist() {
      const query: Record<string, string> = {}
      if (this.shareClassFromCode) {
        query.shareClass = this.shareClassFromCode
      }
      if (/^1\d{10}$/.test(this.phone)) {
        query.mode = 'fast'
        query.mobile = this.phone
      }
      this.$router.push({
        path: '/register',
        query,
      })
    }

    getPicCode() {
      if (!this.validate(this.phone, /^1\d{10}/, i18n.t('ktpMy.请输入正确的手机号') as string)) {
        return;
      }
      this.error = '';
      loginApi.checkLoginMobile(this.phone).then(() => {
        this.isShowPopUp = true;
        loginApi.getFigureCode().then(res => {
          this.sessionid = res.sessionid
          this.picCodeUrl = res.url
        }).catch(e => {
          this.error = e;
        })
      }).catch((e: any) => {
        if (e && (e.code === 30117 || e.code === '30117')) {
          Dialog.confirm({
            title: i18n.t('Common.提示') as string,
            message: i18n.t('Account.手机号未注册请先注册') as string,
            confirmButtonText: i18n.t('Account.去注册') as string,
            cancelButtonText: i18n.t('Common.取消') as string,
          }).then(() => {
            this.goRegist()
          }).catch(() => {})
          return
        }
        this.error = e.message || e;
      })
    }

    confirmPicCode() {
      let mobilexdomain = getMobilexdomain();
      loginApi.sendCode(this.picCodeInput, this.phone, this.sessionid, mobilexdomain, 'login').then(() => {
        this.countDown()
        this.isShowPopUp = false;
        this.checkPicCodeInputError = false;
      }).catch(e => {
        this.getPicCode()
        this.checkPicCodeInputError = true
        this.checkPicCodeInputErrorMessage = e.message
      })
    }

    login() {
      switch (this.loginType) {
        case 'fastLogin': {
          if (this.validate(this.phone, /^1\d{10}/, i18n.t('ktpMy.请输入正确的手机号') as string) &&
          this.validate(this.code, /.+/, i18n.t('Account.请输入短信验证码') as string)) {
            loginApi.loginByMobile(this.phone, this.code).then((res) => {
              let currentLocation:string = window.localStorage.getItem('currentLocation') as string;
              if (res.is_new === 0) {
                if(currentLocation!=null && currentLocation.length>0){
                  if(currentLocation.indexOf("courseHome?courseId=")>=0 || currentLocation.indexOf("joinCourse?code=")>=0){
                     window.localStorage.removeItem('currentLocation');
                     window.location.href = currentLocation;
                  }else  if(currentLocation.indexOf("ShareClass")>=0){
                    window.localStorage.removeItem('currentLocation');
                    
                    this.$router.push({ path: '/joinCourses' ,query: {
                      code:this.shareClassFromCode
                    }});
                    window.localStorage.setItem('token', res.token);
                    return 
                 }
                }
                this.loginSucceed(res, '/');
              } else {
                Dialog.confirm({
                  title: i18n.t('Common.提示') as string,
                  message: i18n.t('Account.手机号未注册请先注册') as string,
                  confirmButtonText: i18n.t('Account.去注册') as string,
                  cancelButtonText: i18n.t('Common.取消') as string,
                }).then(() => {
                  this.goRegist()
                }).catch(() => {})
              }
            }).catch(e => {
              this.error = e.message;
            })
          }
          break
        }
        case 'usrNamePwd': {
          if (this.validate(this.userName, /.+/, i18n.t('Account.请输入用户名') as string) &&
          this.validate(this.password, /.{6,}/, i18n.t('Account.请输入6位以上密码') as string)) {
            loginApi.login(this.userName, this.password).then(res => {
              //触发了安全机制，密码过于简单了，需要提示用户去重置密码
              //@ts-ignore
              if(res.safe == 1){
                let message = "<div style='text-align:left;'>您当前的<span style='color:red;'>密码安全性较低</span>，请重置密码后再次登录</div>";
                Dialog.alert({
                  title: "账号安全提示",
                  message: message,
                  allowHtml:true,
                  confirmButtonText:'前往重置密码',
                  className:'message-dialog-alin-left',
                }).then(()=>{
                  this.$router.push({
                    path: '/findPassword',
                    query:{
                      bigTitle:'重置密码',
                      jsondata:JSON.stringify(res),
                    }
                  });
                });
              }else{
                let currentLocation:string = window.localStorage.getItem('currentLocation') as string;
                if(currentLocation!=null && currentLocation.length>0){
                  if(currentLocation.indexOf("courseHome?courseId=")>=0 || currentLocation.indexOf("joinCourse?code=")>=0){
                      window.localStorage.removeItem('currentLocation');
                      window.location.href = currentLocation;
                  }else if(currentLocation.indexOf("ShareClass")>=0){
                      window.localStorage.removeItem('currentLocation');
                      this.$router.push({ path: '/joinCourses' ,query: {
                        code:this.shareClassFromCode
                      }});
                      window.localStorage.setItem('token', res.token);
                      return 
                  }
                }
                this.loginSucceed(res, '/');
              }
            }).catch(e => {
              this.error = e.message;
            })
          }
          break;
        }
        default:{
          this.error = 'login type error:' + this.error;
        }
      }
    }

    loginByWechat() {
      let appid;
      enum stateType  {
        normalLogin= 'normalLogin',
        loginByWechat= 'loginByWechat',
      }
      if (window.localStorage.getItem('appid_cache')) {
        appid = window.localStorage.getItem('appid_cache') as string;
      } else {
        appid = urlConfig.appid;
      }
      function makeWechatRedirectUri (appid: string, redirectUri: string):(state: stateType)=>string {
        return function(state: stateType) {
          const uri = encodeURIComponent(redirectUri + '/preLogin');
          return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${uri}&response_type=code&scope=snsapi_userinfo&state=${state}`;
        };
      }
      window.location.href = makeWechatRedirectUri(appid, urlConfig.redirectUri)(stateType.loginByWechat)
    }

    getUserInfo() {
      let secondDomain = getMobilexdomain();
      return getUserInfo({secondDomain:secondDomain})
    }

    loginSucceed (
      res: {
        token: string
      },
      to: string,
      query?:object):void {
        window.localStorage.setItem('token', res.token);
        this.$store.dispatch('setUserInfo').then(() => {
          if (query) {
            this.$router.push({
              path: to,
              query: query as any,
            })
          } else {
            this.$router.push(to);
          }
          window.dispatchEvent(new CustomEvent('onLoginSucceed'))
        });
    }
    
    created() {
      this.wechat_code = this.$route.query.code as string | undefined || '';
      this.shareClassFromCode=this.$route.query.shareClass;
      //对携带过来的学校的domian进行处理
      this.disposeDomain();
    }

    disposeDomain(){
      let schoolConfigObj = getSchoolConfig();
      if(schoolConfigObj!=null){
        if(schoolConfigObj['mobileBanner'] && schoolConfigObj['mobileBanner'].length>0){
          this.bannerpic = schoolConfigObj['mobileBanner'];
        }
        this.schoolName = schoolConfigObj['schoolName'];
      }else{
        this.bannerpic = require('@/assets/images/logo_login_banner.png');
      }
    }

    mounted() {
      Toast.clear();
    }

    countDown() {
      if(this.timeLeftNumber !== 0) return;
      this.timeLeftNumber = 60;
      const timeOutId = setInterval(() => {
        if (this.timeLeftNumber === 0) {
          clearInterval(timeOutId);
        } else {
          this.timeLeftNumber -=1
        }
      }, 1000)
    }

    validate(param:string, rule:RegExp, errorMsg: string):boolean {
      rule.test(param)?this.error = '':this.error = errorMsg;
      return rule.test(param)
    }

    clearForm() {
      this.error = '';
      this.phone = '';
      this.code = '';
      this.userName = '';
      this.password = '';
    }

  }
